"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.find-index.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.object.get-prototype-of.js");
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var SuborganizationProgram = /*#__PURE__*/function (_React$Component) {
  _inherits(SuborganizationProgram, _React$Component);
  var _super = _createSuper(SuborganizationProgram);
  function SuborganizationProgram(props) {
    var _this;
    _classCallCheck(this, SuborganizationProgram);
    _this = _super.call(this, props);
    _this.selectProgram = function (e, categoryId, programCheckedList, programNameList) {
      _this.props.handleSelectProgram(e, categoryId, programCheckedList, programNameList);
    };
    _this.getAllPrograms = function () {
      _this.props.handleGetAllPrograms();
    };
    _this.programCheckbox = function (e) {
      _this.props.handleProgramCheckbox(e);
    };
    _this.state = {
      programCheckedList: [],
      programSelected: false
    };
    return _this;
  }
  _createClass(SuborganizationProgram, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.handlePrograms) {
        this.props.handlePrograms();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var programs = this.props.programs;
      var _this$props = this.props,
        programCheckedList = _this$props.programCheckedList,
        programSelected = _this$props.programSelected,
        programNameList = _this$props.programNameList,
        displayError = _this$props.displayError,
        errorMessage = _this$props.errorMessage,
        useSuborgToggle = _this$props.useSuborgToggle,
        disabledProgramCheckedList = _this$props.disabledProgramCheckedList,
        editMode = _this$props.editMode;
      var programsGroupedByCategory = _lodash.default.chain(programs).groupBy('programCategoryName').map(function (value, key) {
        return {
          categoryName: key,
          programsList: value
        };
      }).value();
      return /*#__PURE__*/_react.default.createElement("div", {
        id: "programs-section"
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Header, {
        as: "h4",
        className: "programs-header"
      }, editMode ? 'Manage assigned programs' : 'Assign programs', /*#__PURE__*/_react.default.createElement(_semanticUiReact.Header.Subheader, null, "Choose programs you wish to add to this suborganization.")), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Divider, null), /*#__PURE__*/_react.default.createElement("div", {
        id: "programs-list-container",
        className: "".concat(displayError ? 'errorBorderLine' : null)
      }, useSuborgToggle ? _lodash.default.map(programsGroupedByCategory, function (categoryId, pos) {
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
          className: "programs-list"
        }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Checkbox, {
          key: "".concat(categoryId.categoryName, "_").concat(pos),
          id: "selectprogram_".concat(pos),
          className: "container select-all",
          onClick: function onClick(e) {
            return _this2.selectProgram(e, categoryId, programCheckedList, programNameList);
          },
          checked: _lodash.default.reduce(categoryId.programsList, function (condition, p) {
            return condition && _lodash.default.findIndex(programCheckedList, function (e) {
              return e === p.programId;
            }) != -1;
          }, true),
          label: categoryId.categoryName
        })), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Divider, null), _lodash.default.map(categoryId.programsList, function (programsList, pos) {
          var programId = programsList.programId,
            programDescription = programsList.programDescription,
            programName = programsList.programName;
          return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Checkbox, {
            key: "".concat(programName, "_").concat(pos),
            id: "program_".concat(programId),
            className: "container programs-list",
            name: "".concat(programName),
            value: programId,
            onChange: _this2.programCheckbox,
            checked: _lodash.default.includes(programCheckedList, programId),
            label: "".concat(programName),
            disabled: _lodash.default.includes(disabledProgramCheckedList, programId)
          });
        }), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Divider, null));
      }) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Checkbox, {
        id: "selectAllPrograms",
        className: "container select-all",
        onClick: this.selectProgram,
        checked: programSelected,
        label: "All Mitigation: Hazards grant programs"
      }), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Divider, null), _lodash.default.map(programs, function (program, index) {
        var programId = program.programId,
          programDescription = program.programDescription,
          programName = program.programName;
        return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Checkbox, {
          key: index,
          id: "program_".concat(programId),
          className: "container programs-list",
          name: "".concat(programName),
          value: programId,
          onChange: _this2.programCheckbox,
          checked: _lodash.default.includes(programCheckedList, programId),
          label: "".concat(programName),
          disabled: _lodash.default.includes(disabledProgramCheckedList, programId)
        });
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "errorMessages"
      }, displayError !== 'undefined' ? errorMessage : null));
    }
  }]);
  return SuborganizationProgram;
}(_react.default.Component);
var _default = SuborganizationProgram;
exports.default = _default;